import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7epwzqn7do: FaireBrandEntity = {
  token: "b_7epwzqn7do",
  type: "brand",
  name: "Zero Waste MVMT",
  avatarUrl:
    "https://cdn.faire.com/fastly/c55aab9451a0bba5a68c0e273ee1da6e99902778acab42c2233528eaca8e17f8.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f3ad525326c6d542dfd31a2900b7644ff0851607bd61e3568d5ab8159241c9e4.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c55aab9451a0bba5a68c0e273ee1da6e99902778acab42c2233528eaca8e17f8.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f3ad525326c6d542dfd31a2900b7644ff0851607bd61e3568d5ab8159241c9e4.png",
  location: "Winnipeg, MB, CAN",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 187,
  isInsider: false,
  description:
    "Our Mission: We believe in making a difference—one sustainable product at a time. Zero Waste MVMT was born out of a passion for reducing waste and supporting a cleaner, healthier planet. Every product we create is designed with purpose, blending functionality with eco-conscious design to help you reduce waste in your daily life.\n\nOur Why: Living with Purpose and Impact: We believe sustainable living should be accessible to all, and that small changes can create a powerful movement. Our products are crafted to be safe for you and the earth, made from materials that are biodegradable, compostable, or recyclable. Every product we offer—from kitchen essentials to personal care—is thoughtfully designed to keep waste out of our landfills and oceans.\n\nHow It All Started: Zero Waste MVMT was born out of a desire to do better—for our planet and our future. Founded in 2019 by Zac and Janelle, the idea came after nearly a year of traveling and witnessing firsthand the global waste crisis. In regions with limited waste management, they saw plastic polluting beaches, gathering in makeshift landfills, and even burned along roadsides.\n\nThese experiences inspired Zac and Janelle to create change at the source—by designing eco-friendly alternatives that prevent waste and pollution from the start.\n\nThank you for being on this journey with us!\n\nMuch Love,\nZac & Janelle",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:36.572Z",
    importedBy: "entity-db-cli",
  },
};
